<template>
    <div>
        <basic-container>
            <avue-crud :option="tableOption"
                       :data="tableData"
                       :table-loading="tableLoading"
                       :page="page"
                       ref="crud"
                       @search-change="searchChange"
                       @refresh-change="refreshChange"
                       @row-save="handleSave"
                       @row-update="handleUpdate"
                       @size-change="pageSizeChange"
                       @current-change="pageChange">

                <template slot-scope="scope" slot="menuLeft">
                    <el-button type="primary"
                               icon="el-icon-check"
                               size="small"
                               plain
                               v-if="permission.JOINS_SALES_CLOUD_POINTS_EDIT"
                               @click.stop="handleAward(scope.row,scope.index)">提交奖惩申请
                    </el-button>
                </template>
                <template slot-scope="scope" slot="menu">
                </template>
            </avue-crud>
            <template>
                <el-dialog title="员工积分奖惩" :visible.sync="formDialog" align="center">
                    <el-form :model="oneForm" status-icon ref="oneForm" class="form" size="medium">
                        <el-form-item label="员工">
                            <el-select v-model="oneForm.stuff"
                                       placeholder="请选择员工"
                                       required
                                       value-key="id">
                                <el-option v-for="stuff in stuffs" :key="stuff.id" :label="stuff.name"
                                           :value="stuff"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="奖惩类型">
                            <el-select v-model="oneForm.type"
                                       placeholder="请选择奖惩类型"
                                       required
                                       @change="choose(oneForm.type)"
                                       value-key="value">
                                <el-option v-for="type in types" :key="type.value" :label="type.label"
                                           :value="type"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="奖惩规则">
                            <el-select v-model="oneForm.rule"
                                       placeholder="请选择奖惩规则"
                                       required
                                       @change="choseRule"
                                       value-key="id">
                                <el-option key="" label="自定义"
                                           value=""></el-option>
                                <el-option v-for="rule in rules" :key="rule.id" :label="rule.pointsDescribe"
                                           :value="rule"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="积分值">
                            <el-input type="number" v-model="oneForm.points" >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="描述">
                            <el-input type="textarea" v-model="oneForm.describe" >
                            </el-input>
                        </el-form-item>
                        <el-form-item align="center">
                            <el-button style="margin-top: 12px;"  @click="handleCommit">提交</el-button>
                        </el-form-item>
                    </el-form>
                </el-dialog>
            </template>
        </basic-container>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import { pointsTableOption } from "@/const/salesCloud/pointsOption";
    import { findPoints, awardAndPunish } from "@/api/salesCloud/points"
    import { findPointsRuleAll,choose } from "@/api/salesCloud/pointsRule"
    import { findStuffAll } from "@/api/salesCloud/stuff"
    import {DIC} from "@/const/dic"

    export default {
        name: "points",
        components: {},
        data() {
            return {
                tableOption: pointsTableOption, //表格设置属性
                tableData: [], //表格的数据
                tablePage: 1,
                tableLoading: false,
                formDialog: false,
                tabelObj: {},
                oneForm: {},
                page: {
                    total: 0, //总页数
                    currentPage: 1, //当前页数
                    pageSize: 10 //每页显示多少条
                },
                grade: {
                    box: false,
                    check: []
                },
                types: DIC.POINTS_RULE_TYPE,
                rules: [],
                selectRow: {},
                stuffs:[]
            };
        },
        created() {
            this.handleList();
            findPointsRuleAll().then((res) => {
                let data = JSON.parse(res.data);
                this.rules = data.rows
            })
            findStuffAll().then((res) => {
                let data = JSON.parse(res.data);
                this.stuffs = data
            })

        },
        watch: {},
        mounted() {
        },
        computed: {
            ...mapGetters(["permission"])
        },
        props: [],
        methods: {
            choseRule(row){
                if(null != row){
                  this.oneForm.points = row.points
                  this.oneForm.describe = row.pointsDescribe
                }
            },
            handleCommit(){
                let data = new Object()
                console.log(this.oneForm)
                data.type = this.oneForm.type.value
                if(null != this.oneForm.rule){
                    data.ruleId = this.oneForm.rule.id
                }
                data.points = this.oneForm.points
                data.describe = this.oneForm.describe
                data.stuffId = this.oneForm.stuff.id
                awardAndPunish(data).then((response) => {
                    if(response.code == '200'){
                        this.$message({
                            showClose: true,
                            message: "操作成功",
                            type: "success"
                        });
                        this.handleList();
                    }else{
                        this.$message({
                            showClose: true,
                            message: response.message,
                            type: "error"
                        })
                    }
                    this.formDialog = false
                })

            },
            handleAward(row){
                this.selectRow = row
                this.formDialog = true
            },
            pageSizeChange(pageSize) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = this.page.currentPage,
                    params.size = pageSize
                findPoints(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: this.page.currentPage,
                        pageSize: pageSize
                    };
                    this.tableLoading = false;
                })
            },
            pageChange(page) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = page
                params.size = this.page.pageSize
                findPoints(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: page,
                        pageSize: this.page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            searchChange(params) {
                this.tableLoading = true;
                // let params = this.$refs.crud.searchForm
                params.page = this.page.currentPage
                params.size = this.page.pageSize
                findPoints(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: params.page,
                        pageSize: params.size
                    };
                    this.tableLoading = false;
                })
            },
            refreshChange(page) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = page.currentPage
                params.size = page.pageSize
                findPoints(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: page.currentPage,
                        pageSize: page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            /**
             * @title 打开新增窗口
             * @detail 调用crud的handleadd方法即可
             *
             **/
            handleAdd() {
                this.$refs.crud.rowAdd();
            },
            handleEdit(row, index) {
                this.$refs.crud.rowEdit(row, index);
            },
            /**
             * @title 获取数据
             * @detail 赋值为tableData表格即可
             *
             **/
            handleList() {
                this.tableLoading = true;
                let parmas = {
                    page: this.page.currentPage,
                    size: this.page.pageSize
                }
                findPoints(parmas).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: this.page.currentPage,
                        pageSize: this.page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            /**
             * @title 数据添加
             * @param row 为当前的数据
             * @param done 为表单关闭函数
             *
             **/
            handleSave(row, done) {
                done();
            },
            /**
             * @title 数据删除
             * @param row 为当前的数据
             * @param index 为当前更新数据的行数
             *
             **/
            handleDel(dicName, label) {

            },
            /**
             * @title 数据更新
             * @param row 为当前的数据
             * @param index 为当前更新数据的行数
             * @param done 为表单关闭函数
             *
             **/
            handleUpdate(row, index, done) {
            },
            choose(obj){
                choose(obj.value).then((res) => {
                    let data = JSON.parse(res.data);
                    this.rules =data;
                })

            }
        }
    };
</script>

<style lang="scss">
    .table-container {
        padding: 8px 10px;
    }

    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
</style>
